import { z } from 'zod';
import { AdminActionInput } from '../shared.js';
import { CursorQuery } from '../../common/pagination.js';
// ── commerce: payments & refunds (FR-ADM-50…52) ──────────────────────────
export const RefundInput = AdminActionInput.extend({
    amountMinor: z.number().int().positive().optional(),
});
export const AdminPaymentQuery = CursorQuery.extend({
    kind: z.enum(['subscription', 'donation', 'ticket', 'promotion']).optional(),
    accountId: z.string().optional(),
});
//# sourceMappingURL=schemas.js.map